/* script */


  import ApplicationState         from 'g3w-state';
  import { G3W_FID }              from 'g3w-constants';
  import G3WField                 from 'components/G3WField.vue';
  import GUI                      from 'g3w-app';
  import { getAlphanumericProps } from 'utils/getAlphanumericProps';
  import { getUniqueDomId }       from 'utils/getUniqueDomId';
  import { noop }                 from 'utils/noop';
  import { XHR }                  from 'utils/XHR';

  /**
   * Convert feature to form Data for expression/expression_eval request
   */
  function getFormData(feature, contenttype) {
    let _feature = feature;

    if ('editing' !== contenttype) {
      delete feature.attributes.geometry;

      _feature   = new ol.Feature(feature.geometry);
      const properties = {};

      getAlphanumericProps(feature.attributes)
        .filter(p => G3W_FID !== p)
        .forEach(p => properties[p] = feature.attributes[p]);
      _feature.setProperties(properties);
      _feature.setId(feature.id || feature.attributes[G3W_FID]);
    }

    return (new ol.format.GeoJSON()).writeFeatureObject(_feature);
  }

  const __vue_script__ = {
    name: "g3w-tabs",
    props: {
      group: {
        type:    Boolean,
        default: false
      },
      contenttype: {
        default: 'query'//or editing
      },
      layerid:{
        required: true
      },
      tabs: {
        required: true
      },
      feature: {
        required: true
      },
      fields: {
        required: true
      },
      addToValidate: {
        type:    Function,
        default: noop
      },
      removeToValidate: {
        type:    Function,
        default: noop
      },
      changeInput: {
        type:    Function,
        default: noop
      },
      showRelationByField: {
        type:    Boolean,
        default: true
      },
      handleRelation: {
        type:     Function,
        default: ({ relation, layerId, feature } = {}) => {
          // GUI.showRelations({ layerId, feature });
          GUI.showRelations({ relationId: relation.name, layerId, feature });
        }
      }
    },
    data() {
      return {
        ids : []
      }
    },
    computed: {
      required_fields() {
        return 'editing' === this.contenttype && this.fields.filter(f => f.validate.required).map(f => f.name);
      },
      show() {
        return this.tabs.reduce((a, t) => a || (t.visible === undefined || !!t.visible), false);
      }
    },
    methods: {
      /**
       * ORIGINAL SOURCE: src/app/core/expression/tabservice.js@3.8.6
       */
      async setVisibility(tab) {
        const response = await XHR.post({
          url:         `/api/expression_eval/${ApplicationState.project.getId()}/`,
          contentType: 'application/json',
          data:        JSON.stringify({
            qgs_layer_id: this.layerid,
            form_data:    getFormData(this.feature || {}, this.contenttype),
            expression:   tab.visibility_expression.expression,
            formatter:    ('query' === this.contenttype ? 1 : 0),
          }),
        });
        if (response.result) {
          // in case the tab was previously visible but is now not visible, remove its inputs from validation
          if (tab.visible && !response.value) {
            const removeInputs = nodes => nodes.forEach(node => {
              if (node.nodes) {
                removeInputs(node.nodes);
              } else {
                const field = this.fields.find(field => node.field_name === field.name);
                if (field && !field.query) {
                  this.removeToValidate(field);
                }
              }
            });
            removeInputs(tab.nodes || []);
          }
          tab.visible = response.value;
        } else {
          throw JSON.stringify(response.error);
        }
      },
      // method to set required tab for editing
      setEditingRequireTab(obj = {}) {
        if (undefined === obj.nodes) {
          return this.required_fields.includes(obj.field_name);
        } else {
          return !!obj.nodes.find(n => this.setEditingRequireTab(n));
        }
      },
      getField(name) {
        return this.fields.find(f => name === f.name);
      },
      getNodeType(node) {
        const type = (node.groupbox || node.nodes) ? 'group' : node.relation ? 'relation' : 'field';
        if ('field' === type && [undefined, ''].includes(node.alias)) {
          node.alias = node.field_name;
        }
        return type;
      },
      getNodeRows(node) {
        const nodes = node?.nodes?.filter(child => {
          if ('group' === this.getNodeType(child)) { return true }
          if (!child.nodes && child.name && 'group' != this.getNodeType(child)) {
            child.relation = true;
            return true;
          }
          return !!this.fields.find(field => child.field_name === (field.name || child.relation));
        }) || [];
        if (!nodes.length) { return [] }
        const columns = Math.min(parseInt(node.columncount) || 1, nodes.length);
        const rows = columns <= nodes.length ? Math.floor(nodes.length / columns) + (nodes.length % columns) : 1;
        return Array.from({ length: rows }, (_, index) => nodes.slice(index * columns, (index + 1) * columns));
      },
      getNodeField(node) {
        if (node.relation) { return node }
        const field = this.fields.find(field => node.field_name === field.name);
        field.showlabel = node.showlabel;
        return field;
      },
      loadingRelation(relation) {
        return (ApplicationState.project.getLayerById(this.layerid)?.getRelationById(relation.name) || { state: { loading: false } }).state;
      },
      isRelationDisabled(relation) {
        return undefined === this.getRelationName(relation.name) ||
          ('editing' === this.contenttype && this.isRelationChildLayerNotEditable(relation));
      },
      getRelationName(relationId) {
        return (ApplicationState.project.getRelationById(relationId) || {}).name;
      },
      isRelationChildLayerNotEditable(relation) {
        const projectRelation = ApplicationState.project.getRelationById(relation.name);
        const relationLayer   = ApplicationState.project.getLayerById(projectRelation.referencingLayer);
        return !(relationLayer && relationLayer.isEditable());
      },

      /**
       * Mimics <details> tag behaviour
       * 
       * @since 3.10.0 
       */
      toggleGroup(e) {
        const wrapper = e.target.closest('.tabs-wrapper');
        wrapper.classList.toggle('collapsed');
      },

    },
    components: {
      'g3w-field': G3WField,
    },
    async created() {
      this.unwatch = [];
      this.tabs.forEach(async (tab , i) => {
        if (tab.visibility_expression) {
          if (undefined === tab.visible) { this.$set(tab, 'visible', 0) }
          await this.setVisibility(tab);
        }
        if ('editing' === this.contenttype) {
          if (undefined === tab.required) {
            tab.required = this.setEditingRequireTab(tab);
          }
          if (tab.visibility_expression) {
            tab.visibility_expression
              .referenced_columns
              .forEach(c => {
                const field = this.fields.find(f => c === f.name);
                this.unwatch.push(
                  this.$watch(() => field.value,
                    async () => {
                      //need to wait that form set new value of change field to feature
                      await this.$nextTick();
                      await this.setVisibility(tab);
                    })
                )
              })
          }
        }
        this.ids.push(`tab_${getUniqueDomId()}`);
      });

      this.root_tabs = [];
      if (!this.group) {
        const nodes = [];
        this.tabs.forEach(tab_node => {
          if (tab_node.nodes) { nodes.push(tab_node) }
          else {
            if (nodes.length) {
              this.root_tabs.push([...nodes]);
              nodes.splice(0);
            }
            this.root_tabs.push({nodes:[tab_node]});
          }
        });
        if (nodes.length) {
          this.root_tabs.push(nodes);
        }
      } else {
        this.root_tabs = [this.tabs];
      }
    },
    beforeDestroy() {
      this.unwatch.forEach(u => u());
      this.unwatch = null;
    }
  }


/* template */
var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"tabs-wrapper"},[_vm._l((_vm.root_tabs),function(root_tab,i){return [(Array.isArray(root_tab))?[_c('ul',{staticClass:"formquerytabs nav nav-tabs"},[_vm._l((root_tab),function(tab,index){return [(tab.visible === undefined || tab.visible)?_c('li',{class:{active: index === 0}},[_c('a',{staticClass:"tab_a",class:{'mobile': _vm.isMobile(), 'group-title': _vm.group},style:({fontSize: _vm.isMobile() ? '1.0em': `${_vm.group ? '1.1': '1.2'}em`}),attrs:{"data-toggle":"tab","href":`#${_vm.ids[index]}`},on:{"click":function($event){_vm.group && _vm.toggleGroup($event)}}},[_vm._v("\n               "+_vm._s(tab.name)+" "),(_vm.contenttype === 'editing' && tab.required)?_c('span',{staticStyle:{"padding-left":"3px","font-size":"1.1em"}},[_vm._v("*")]):_vm._e()])]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"tab-content",class:{editing: 'editing' === _vm.contenttype }},[_vm._l((root_tab),function(tab,index){return [(undefined === tab.visible || tab.visible)?_c('div',{staticClass:"tab-pane",class:{'active': index === 0},attrs:{"id":_vm.ids[index]}},[_c('div',{staticClass:"tab-node group"},_vm._l((_vm.getNodeRows(tab)),function(row){return _c('div',{staticClass:"node-row",class:{'mobile': _vm.isMobile()}},[_vm._l((row),function(column){return [('field' === _vm.getNodeType(column))?_c('g3w-field',{staticStyle:{"padding":"5px 3px 5px 3px"},attrs:{"state":_vm.getNodeField(column),"field-type":_vm.getNodeField(column).query && _vm.getNodeField(column).input.type || 'input',"changeInput":_vm.changeInput,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"feature":_vm.feature},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}}):('group' === _vm.getNodeType(column))?_c('g3w-tabs',_vm._b({staticClass:"sub-group",staticStyle:{"width":"100% !important"}},'g3w-tabs',{ ..._vm.$props, group: true, tabs: [column] },false)):(_vm.showRelationByField)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.isRelationDisabled(column) || _vm.loadingRelation(column).loading),expression:"isRelationDisabled(column) || loadingRelation(column).loading"}],style:({cursor: _vm.showRelationByField && 'pointer'}),on:{"click":function($event){$event.stopPropagation();return _vm.handleRelation({ relation: column, feature: _vm.feature, layerId: _vm.layerid })}}},[(_vm.loadingRelation(column).loading)?_c('div',{staticClass:"bar-loader",staticStyle:{"border":"0"}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"query_relation_field"},[_c('i',{class:'query' === _vm.contenttype ? 'fas fa-sitemap' : 'fas fa-pencil-alt'})]),_vm._v(" "),_c('span',{staticClass:"query_relation_field_message g3w-long-text"},[_c('span',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.getRelationName(column.name)))])])])]):_vm._e()]})],2)}),0)]):_vm._e()]})],2)]:_c('div',{staticClass:"tab-node group",class:[(i % 2) ? 'odd' : 'even']},_vm._l((_vm.getNodeRows(root_tab)),function(row){return _c('div',{staticClass:"node-row",class:{'mobile': _vm.isMobile()}},[_vm._l((row),function(column){return [('field' === _vm.getNodeType(column))?_c('g3w-field',{staticStyle:{"padding":"5px 3px 5px 3px"},attrs:{"state":_vm.getNodeField(column),"field-type":_vm.getNodeField(column).query && _vm.getNodeField(column).input.type || 'input',"changeInput":_vm.changeInput,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"feature":_vm.feature},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}}):('group' === _vm.getNodeType(column))?_c('g3w-tabs',_vm._b({staticClass:"sub-group",staticStyle:{"width":"100% !important"}},'g3w-tabs',{ ..._vm.$props, group: true, tabs: [column] },false)):(_vm.showRelationByField)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.isRelationDisabled(column) || _vm.loadingRelation(column).loading),expression:"isRelationDisabled(column) || loadingRelation(column).loading"}],style:({cursor: _vm.showRelationByField && 'pointer'}),on:{"click":function($event){$event.stopPropagation();return _vm.handleRelation({ relation: column, feature: _vm.feature, layerId: _vm.layerid })}}},[(_vm.loadingRelation(column).loading)?_c('div',{staticClass:"bar-loader",staticStyle:{"border":"0"}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"query_relation_field"},[_c('i',{class:'query' === _vm.contenttype ? 'fas fa-sitemap' : 'fas fa-pencil-alt'})]),_vm._v(" "),_c('span',{staticClass:"query_relation_field_message g3w-long-text"},[_c('span',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.getRelationName(column.name)))])])])]):_vm._e()]})],2)}),0)]})],2):_vm._e()
}
var staticRenderFns = []

const __vue_render__ = render;
const __vue_staticRenderFns__ = staticRenderFns;

const __vue_component__ = __vue_script__;
__vue_component__.render = __vue_render__;
__vue_component__.staticRenderFns = __vue_staticRenderFns__;
__vue_component__._compiled = true;
__vue_component__.__file = "/home/volterra79/G3W-SUITE/g3w-client/src/components/G3WTabs.vue";
__vue_component__._scopeId = "data-v-0158b9a8";
/* style inject */
import __vue_create_injector__ from 'g3w-vue:style-injector';
[{"id":"0158b9a8-0","css":".formquerytabs.nav-tabs>li[data-v-0158b9a8]{margin-right:3px}.formquerytabs.nav-tabs>li[data-v-0158b9a8]:last-child{margin-right:0}.formquerytabs.nav-tabs li:not(.active)>a[data-v-0158b9a8]{color:var(--skin-color);background-color:hsl(from var(--skin-color) h s calc(l + 48))!important;border:1px solid hsl(from var(--skin-color) h s calc(l + 30));margin:0 3px 3px 0;border-bottom:0!important}.formquerytabs.nav-tabs li>a[data-v-0158b9a8]{color:var(--skin-color)}.formquerytabs.nav-tabs li a.tab_a.group-title[data-v-0158b9a8]{background-color:hsl(from var(--skin-color) h s calc(l + 20))!important}.formquerytabs.nav-tabs li.active>a[data-v-0158b9a8],.formquerytabs.nav-tabs li.active>a[data-v-0158b9a8]:focus,.formquerytabs.nav-tabs .nav-tabs>li.active>a[data-v-0158b9a8]:hover{background-color:var(--skin-color)!important;color:#fff}.skin-green .formquerytabs.nav-tabs li:not(.active)>a[data-v-0158b9a8]{background-color:#e4ffcb!important}.skin-green .formquerytabs.nav-tabs li a.tab_a.group-title[data-v-0158b9a8]{background-color:#3da65ad9!important}.skin-red .formquerytabs.nav-tabs li:not(.active)>a[data-v-0158b9a8]{background-color:hsl(from var(--skin-danger) h s calc(l + 40))!important}.skin-yellow .formquerytabs.nav-tabs li:not(.active)>a[data-v-0158b9a8]{background-color:#fffdfa!important;border:1px solid var(--skin-warning-d40)}.formquerytabs[data-v-0158b9a8]{overflow:hidden!important;display:flex;flex-wrap:wrap}.formquerytabs>li[data-v-0158b9a8]{flex:1;display:flex}.formquerytabs>li>a[data-v-0158b9a8]{font-weight:700;flex:1}.nav-tabs>li>a.mobile[data-v-0158b9a8]{padding:5px 10px}.tab_a[data-v-0158b9a8]{padding:5px;margin-right:0!important;border-bottom:0;margin-bottom:3px;border-radius:3px 3px 0 0}.formquerytabs li a.tab_a.group-title[data-v-0158b9a8]{color:inherit!important;font-weight:500;font-size:1em!important;padding:.25em;cursor:pointer}.tabs-wrapper>.formquerytabs li a.tab_a.group-title[data-v-0158b9a8]:before{content:\"\\25be\"}.tabs-wrapper.collapsed>.formquerytabs li a.tab_a.group-title[data-v-0158b9a8]:before{content:\"\\25b8\"}.tabs-wrapper.collapsed>.formquerytabs+.tab-content[data-v-0158b9a8]{display:none}\n","media":"","filename":"src/components/G3WTabs.vue"},{"id":"0158b9a8-1","css":".tabs-wrapper .tab-node{min-width:0;overflow:hidden}.tabs-wrapper .tab-node.odd{background-color:hsl(from var(--skin-color) h s l / .1)}.tabs-wrapper .tab-node>.node-row{margin-bottom:0;column-gap:2px;margin-top:0;display:grid;grid-auto-columns:minmax(0,1fr);grid-auto-flow:column}\n","media":"","filename":"src/components/G3WTabs.vue"}].forEach(__vue_create_injector__());
export default __vue_component__;